/**
 * "Add the chat widget to your site" — Guides section (ADR-0074).
 * Composes the documented flow: CLI discovery → review the catalog → design the
 * widget → embed the snippet. Links to each canonical page rather than restating.
 */
import type { DocPageContent } from '../types';

export const GUIDES_LAUNCH_ASSISTANT_PAGE: DocPageContent = {
  slug: 'guides/launch-assistant',
  titleKey: 'docs.guides.launch.title',
  descriptionKey: 'docs.guides.launch.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.launch.lead' },

    { kind: 'heading', level: 2, id: 'before', textKey: 'docs.guides.launch.before.heading' },
    {
      kind: 'list',
      itemKeys: [
        'docs.guides.launch.before.account',
        'docs.guides.launch.before.api',
        'docs.guides.launch.before.key',
      ],
    },

    { kind: 'heading', level: 2, id: 'steps', textKey: 'docs.guides.launch.steps.heading' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.guides.launch.step.discover.title',
          textKey: 'docs.guides.launch.step.discover.text',
        },
        {
          titleKey: 'docs.guides.launch.step.review.title',
          textKey: 'docs.guides.launch.step.review.text',
        },
        {
          titleKey: 'docs.guides.launch.step.design.title',
          textKey: 'docs.guides.launch.step.design.text',
        },
        {
          titleKey: 'docs.guides.launch.step.embed.title',
          textKey: 'docs.guides.launch.step.embed.text',
        },
        {
          titleKey: 'docs.guides.launch.step.verify.title',
          textKey: 'docs.guides.launch.step.verify.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.guides.launch.snippet.title',
      textKey: 'docs.guides.launch.snippet.body',
      links: {
        config: {
          target: { docSlug: 'widget/configuration' },
          labelKey: 'docs.guides.launch.snippet.link',
        },
      },
    },
    {
      // D31 part 2 — the honest SRI story: integrity= is impossible on the
      // mutable widget.js URL; the version-skew warning is the signal.
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.guides.launch.integrity.title',
      textKey: 'docs.guides.launch.integrity.body',
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.launch.related.cli.title',
          textKey: 'docs.guides.launch.related.cli.text',
          to: { docSlug: 'cli/init' },
        },
        {
          titleKey: 'docs.guides.launch.related.design.title',
          textKey: 'docs.guides.launch.related.design.text',
          to: { docSlug: 'dashboard/design' },
        },
        {
          titleKey: 'docs.guides.launch.related.theming.title',
          textKey: 'docs.guides.launch.related.theming.text',
          to: { docSlug: 'widget/theming' },
        },
      ],
    },
  ],
};
